import { DeheadingQAQC } from "../entities/de-heading-qa-qc.entity";
import { DeheadingSample } from "../entities/deheading-sample.entity";
import { DeheadingQaQcDto } from "./deheading-qa-qc.dto";
import { DeHeadingSampleDto } from "./deheading-sample.dto";

export class DeheadingSampleAdapter {
    public convertDtoToEntity(sampleDto: DeheadingQaQcDto): DeheadingQAQC {
        const qaQcEntity = new DeheadingQAQC();
        qaQcEntity.hLessQty = sampleDto.hLessQty;
        qaQcEntity.hOnQty = sampleDto.hOnQty;
        qaQcEntity.jobNo = sampleDto.jobNo;
        qaQcEntity.plantId = sampleDto.plantId;
        qaQcEntity.batchNo = sampleDto.batchNo;
        qaQcEntity.varietyOfMaterial = sampleDto.varietyOfMaterial;
        qaQcEntity.logId = sampleDto.logId;
        
        if (sampleDto.deheadingQAQCId) {
            qaQcEntity.updatedUser = sampleDto.updatedUser;
            qaQcEntity.deheadingQAQCId = sampleDto.deheadingQAQCId;
        } else {
            qaQcEntity.sampleCode = sampleDto.sampleCode;
            qaQcEntity.createdUser = sampleDto.createdUser;
        }
        const sampleEntity: DeheadingSample[] = [];
        for (const sample of sampleDto.deheadingSampleInfo) {
            const entity = new DeheadingSample();
            entity.deterioration = sample.deterioration;
            entity.discoloration = sample.discoloration;
            entity.hangingMeatOrThroat = sample.hangingMeatOrThroat;
            entity.improperDeheading = sample.improperDeheading;
            entity.plantId = sampleDto.plantId;
            entity.sampleNo = sample.sampleNo;
            entity.softTail = sample.softTail;
            entity.temperature = sample.temperature;
            entity.blackTail = sample.blackTail;
            entity.brokenOrUnUsable = sample.brokenOrUnUsable;
            entity.brownMeat = sample.brownMeat;
            entity.qaQcId = sampleDto.deheadingQAQCId;
            if (sample.deheadingSampleId) {
                entity.deheadingSampleId = sample.deheadingSampleId;
                entity.updatedUser = sample.updatedUser;
            } else {
                entity.createdUser = sampleDto.createdUser;
            }
            sampleEntity.push(entity);
        }

        qaQcEntity.deheadingSampleInfo = sampleEntity;
        return qaQcEntity;
    }
}